var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{class:{ active: _vm.scope.tab.active, visited: _vm.scope.tab.checked && !_vm.scope.tab.active }},[_vm._v("\n  "+_vm._s(_vm.scope.index + 1)+". "+_vm._s(_vm.scope.tab.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }